import _ from 'lodash';

import { TAccountTypeGQLType } from 'types/dashboard-core-gqlTypes.generated';

export const truncateLiabilityAccountType = (
  accountType: TAccountTypeGQLType,
) => {
  let accountName: string = accountType;
  if (_.startsWith(accountType, 'accrued')) {
    accountName = accountType.slice(7);
  }

  return _.startCase(accountName);
};
